import dayjs from 'dayjs';
import { t } from 'i18next';

/**
 * Render a project completion date as a localised quarter, e.g. `2027-10-15` -> `Q4 2027`
 * (`الربع الرابع 2027` in Arabic). The backend sends an ISO date; the design shows a quarter.
 *
 * Returns null for missing or unparseable input so callers can omit the field entirely rather
 * than printing `Invalid Date` — project completion dates are only ~80% populated.
 */
export const formatCompletionQuarter = (completionDate) => {
  if (!completionDate) return null;

  const date = dayjs(completionDate);
  if (!date.isValid()) return null;

  const quarter = Math.floor(date.month() / 3) + 1;
  return `${t(`Q${quarter}`)} ${date.year()}`;
};

export default formatCompletionQuarter;
